<template>
  <div class="px-6 lg:px-10 py-6">
    <h1 class="text-[26px] font-bold text-gray-900 mb-12">Trial Balance Report</h1>

    <div v-if="!canView" class="mt-10"></div>

    <DynamicReportForm
      v-else
      v-model="model"
      :fields="fields"
      :columns="2"
      stackAt="md"
      contentWidth="2xl"
      actionLabel="View Report"
      :showTitle="false"
      @submit="onSubmit"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import DynamicReportForm from "@/components/DynamicReportForm.vue"
import { loadMyPermissions, hasAny } from "@/utils/permissions"

const canView = ref(false)

onMounted(async () => {
  await loadMyPermissions(false)
  canView.value = hasAny(["trial_balance_report.view"])
})

const model = ref({
  company_id: "",
  from_date:  "",
  to_date:    "",
})

const fields = [
  {
    name:        "company_id",
    label:       "Company",
    type:        "select",
    span:        "full",
    placeholder: "Select  company",
    loader: async () => [],
  },
  {
    name:        "from_date",
    label:       "From",
    type:        "date",
    span:        "full",
    placeholder: "yyyy/mm/dd",
  },
  {
    name:        "to_date",
    label:       "To",
    type:        "date",
    span:        "full",
    placeholder: "yyyy/mm/dd",
  },
]

function onSubmit(_) {
  // no action yet (backend not implemented)
}
</script>
